package com.neurobs.js.ccab

import com.neurobs.ccab.{CCABServer => CCABServerNew}
import com.neurobs.react.ContextBase

object ServerContext extends ContextBase[CCABServerNew] {
	override protected def defaultStateValue(): CCABServerNew = RelativeJSCCABServer()
}
